import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
import './TestimonialSection.css';

const TestimonialSection = () => {
  const testimonials = [
    {
      company: 'UltraTech Cement Limited — Balaji Cement Works',
      content:
        'Very Good performance. Keep it up. (Vendor performance appraisal: 97.10, Category A — Apr–Jun 2019.)',
      rating: 5
    },
    {
      company: 'KJS Cement (I) Ltd.',
      content:
        'M/s KirBOO Flowsafe successfully serviced our Automatic Recirculation Valve for the Boiler Feed Pump, including spares. The valve was returned to operating condition and continues to show satisfactory performance.',
      rating: 5
    },
    {
      company: 'UltraTech Cement Limited (Aditya Birla Group) — Gujarat Cement Works',
      content:
        'We appreciate the valve servicing and maintenance work at our plant. Their team showed strong technical expertise on high-pressure valves—dismantling, inspection, repair, and calibration—with efficient execution during shutdown and minimum downtime. Workshop support and supply of required spares within the shutdown period was commendable.',
      rating: 5
    },
    {
      company: 'Wood Group Engineering Services — Abu Dhabi, U.A.E.',
      content:
        'M/S Kirboo Flow Safe were engaged with Wood Group Engineering Services for the Takreer Ruwais shutdown from 10 October 2010 to 4 November 2010. Certificate of appreciation issued upon completion of the assignment.',
      rating: 5
    }
  ];

  return (
    <section className="testimonial-section">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="testimonial-header"
        >
          <h2 className="testimonial-title">
            What Our Clients Say
          </h2>
          <p className="testimonial-description">
            Excerpts from official client appreciation letters, certificates, and vendor performance appraisals.
          </p>
        </motion.div>

        <div className="testimonial-grid">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={`${index}-${testimonial.company}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              className="testimonial-card"
            >
              <div className="testimonial-quote">
                <Quote className="w-8 h-8" />
              </div>

              <div className="testimonial-rating">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" />
                ))}
              </div>

              <p className="testimonial-content">
                &ldquo;{testimonial.content}&rdquo;
              </p>

              <div className="testimonial-author">
                <div className="testimonial-company">{testimonial.company}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
